import React, { useState, useRef, useEffect } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { PopupMenu, Button } from 'quantux-ui';
import { blue, gray, salmon } from '../../theme';
import { debugLogToConsole } from '../../utils';

const FacilityLocationCard = (props) => {
  const [showLocationsMenu, setShowLocationsMenu] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState('');
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);

  // __ Effects _________________________________________________________
  useEffect(() => {
    setSelectedLocation(props.selectedLocation);
  }, [props.selectedLocation]);

  // __ Refs ____________________________________________________________
  const popMenuRef = useRef();

  // __ Styles __________________________________________________________
  const styles = StyleSheet.create({
    searchPopupMenuContainer: {
      width: '358px',
      background: blue[900],
      paddingBottom: '1px',
      borderRadius: '5px',
      overflowY: 'auto',
      maxHeight: '200px'
    },
    menuItem: {
      cursor: 'pointer',
      background: '#103860',
      borderRadius: '8px',
      color: gray[300],
      padding: '4px',
      lineHeight: '16px',
      fontSize: '14px',
      marginBottom: '2px',
      ':hover': {
        background: '#184878',
        color: 'white'
      },
      ':last-child': {
        borderBottom: '0'
      }
    },
    menuItemAvatarImg: {
      height: '40px',
      maxHeight: '40px',
      borderRadius: '4px'
    },
    selectedLocation: {
      background: gray[800],
      height: '20px',
      fontSize: '14px',
      display: 'flex',
      paddingLeft: '4px',
      alignItems: 'center'
    },
    deleteWarning: {
      color: salmon[500],
      fontWeight: '700'
    },
    headerText: {
      fontSize: '14px',
      lineHeight: '14px'
    },
    headerTextBold: {
      fontWeight: '700'
    }
  });

  return (
    <div
      className='fac-location-card mt-2'
      style={{
        background: blue[700],
        borderRadius: '4px',
        padding: '8px'
      }}
    >
      {/* Delete warning */}
      {showDeleteWarning &&
        <div className='p-1' style={{ width: '100%', height: '100%' }}>
          {/* Warning message */}
          <div className={`pt-2 pb-2 ${css(styles.deleteWarning)}`}>
            Do you want to delete facility?
          </div>
          <div className='fx mt-2' style={{ justifyContent: 'flex-end' }}>
            <Button
              btnType='primary'
              isOutlineBtn
              className='mr-2'
              onClick={() => {
                setShowDeleteWarning(false);
              }}
            >
              Cancel
            </Button>
            <Button
              btnType='warning'
              onClick={() => {
                props.onDeleteFacility();
              }}
            >
              Continue
            </Button>
          </div>
        </div>
      }

      {/* Header */}
      <div
        className='fx'
        style={{
          display: showDeleteWarning ? 'none' : '',
          justifyContent: 'space-between',
          height: '40px'
        }}
      >
        <div className={css(styles.headerText)}>
          {/* <div className={css(styles.headerTextBold)}>{props.data.facilityName}</div> */}
          <div className={css(styles.headerTextBold)}>
            {props.data.facilityDisplayName || ''}
          </div>
          {/* <div>{props.data.taxonomy}</div> */}
        </div>
        {/* Facility delete button */}
        <div onClick={() => setShowDeleteWarning(true)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="none">
            <path fill="#96C8FF" fillRule="evenodd" d="M20.755 3.259a.88.88 0 0 0-.614-.25h-4.313V1.657C15.828.743 15.089 0 14.18 0H6.818C5.91 0 5.171.743 5.171 1.657V3.01H.837A.84.84 0 0 0 0 3.851c0 .466.374.842.837.842h.738v14.65c0 .914.738 1.657 1.647 1.657h14.79c.909 0 1.647-.743 1.647-1.657V4.693h.481c.46 0 .86-.376.86-.842a.83.83 0 0 0-.245-.592ZM2.49 20.675a1.712 1.712 0 0 1-.103-.1c.032.035.067.067.103.1Zm.123.028c.033.036.067.073.1.1-.02-.017-.04-.038-.061-.06l-.04-.04ZM14.174 1.664H6.816v1.361h7.358v-1.36Zm3.835 17.675H3.222V4.69H18.009V19.34ZM9.647 8.362c0-.468.377-.846.842-.846.465 0 .84.378.84.846v7.853a.843.843 0 0 1-.84.846.843.843 0 0 1-.842-.846V8.362Zm-3.715-.846a.843.843 0 0 0-.84.846v7.853c0 .468.375.846.84.846a.843.843 0 0 0 .842-.846V8.362a.844.844 0 0 0-.842-.846Zm8.225.846c0-.468.376-.846.84-.846.466 0 .842.378.842.846v7.853a.843.843 0 0 1-.841.846.843.843 0 0 1-.841-.846V8.362Z" clipRule="evenodd" />
          </svg>
        </div>
      </div>

      {/* Select Location */}
      <div
        style={{
          position: 'relative',
          display: showDeleteWarning ? 'none' : ''
        }}
      >
        <div
          ref={popMenuRef}
          style={{ position: 'relative' }}
        >
          <div
            onClick={() => setShowLocationsMenu(true)}
            className={css(styles.selectedLocation)}
            style={{ color: props.selectedLocation === 'TBD (To Be Determined)' ? props.msgColor : '' }}
          >
            {`Room ${selectedLocation}`}
            <i className='ml-2 fa fa-chevron-down' />
          </div>
          {showLocationsMenu &&
            <PopupMenu
              top={30}
              left={-1}
              zIndex='1550'
              position="absolute"
              visible={showLocationsMenu}
              parent={popMenuRef}
              onOutsideClick={() => { setShowLocationsMenu(false); }}
            >
              <div className={css(styles.searchPopupMenuContainer)}>
                <div
                  className={`fx fx__v-center ${css(styles.menuItem)}`}
                  style={{
                    height: '40px',
                    width: '341px',
                    color: props.msgColor
                  }}
                  onClick={() => {
                    props.onSelectLocation('TBD (To Be Determined)');
                    setShowLocationsMenu(false);
                  }}
                >
                  TBD (To Be Determined)
                </div>
                {props.locations && props.locations.length > 0 &&
                  props.locations.map((el, idx) => (
                    <div
                      key={`${el._id}__${idx}`}
                      className={`fx fx__v-center ${css(styles.menuItem)}`}
                      style={{ height: '40px', width: '341px' }}
                      onClick={() => {
                        props.onSelectLocation(el);
                        setShowLocationsMenu(false);
                      }}
                    >
                      {el}
                    </div>
                  ))
                }
              </div>
            </PopupMenu>
          }
        </div>
      </div>
    </div>
  );
};

export default FacilityLocationCard;
